module.exports = __webpack_public_path__ + "static/media/backButton.2624e8b7.svg";